<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>

import VueTypes from "vue-types";

import {ItemTraderMode} from "@/modules/redactor/models/item/trader/ItemTraderMode";

export default {
  name: "r-item-trader-mode",
  props: {
    model: VueTypes.instanceOf(ItemTraderMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemTraderMode.getValues();
    }
  }
}
</script>